import * as React from 'react';
import { useSearch } from '@elastic/react-search-ui';
import { Config } from "../../helper";

export default function OpenSearchResultsCount() {
  const {
    current,
    resultsPerPage,
    totalResults,
  } = useSearch();

  const calculatedStart = (current - 1) * resultsPerPage + 1;
  const potentialEnd = calculatedStart + resultsPerPage - 1;
  const calculatedEnd = Math.min(potentialEnd, totalResults);

  return (
    <div className='result-count text-center'>
      <strong>{calculatedStart} – {calculatedEnd}</strong> {Config.I18n.Pager.OfTotal(totalResults)}
    </div>
  );
}
